import { IApplicationState } from '../../types/redux';

/**
 * Выбирает дискуссии
 */
export const selectDiscussions = ({ discussions }: IApplicationState) => discussions;
